import { Record } from 'immutable';
import { schema } from 'normalizr';

export const SmartlinkParameter = new Record({
  id: undefined,
  next_sunrise_sent_to_unit: undefined,
  next_sunset_sent_to_unit: undefined,
  current_bias: undefined,
  threshold_percentage: undefined,
  offline_days: undefined,
  over_the_air_programming_active: undefined,
  ota_programming_segment: undefined,
  ota_response_code: undefined,
  sample_time: undefined,
  on_delay: undefined,
  max_data_session: undefined,
  power_restore_timeout: undefined,
  check_in_time: undefined,
  has_surge_Arrestor: undefined,
  has_pre_release_verizon_firmware: undefined,
  weather_lights_on: undefined,
  triface_time: undefined,
  relay_controller: undefined,
  auto_linked_to_third_party_manager: undefined,
  warranty_end: undefined,
  warranty_start: undefined,
  ota_version: undefined,
  door_sensor_automatically_configured: undefined,
  cic_automatically_configured: undefined,
  power_meter_type: undefined,
  ansi_meter1_voltage: 120,
  ansi_meter2_voltage: 120,
});

export const smartlinkParameterSchema = new schema.Entity('smartlinkParameters');

// for reading in nested models, object with { field: schema }
// smartlinkParameterSchema.define({  });
